import { ITracingSegment } from "../../infrastructure/tracing-segment.interface";
import { IProcessable } from "../components/pipeline/processable.interface";
import { IPipeline } from "../pipelines/pipeline.inferface";
import { TracingComponent } from "../pipelines/tracing-component";
import { TracingPipeline } from "../pipelines/tracing-pipeline";

export class TracingClassFactory {

	public createTracingComponent(segment: ITracingSegment, component: IProcessable<any>): TracingComponent<any, any> {
		return new TracingComponent(component, segment);
	}

	public createTracingPipeline(segment: ITracingSegment, pipeline: IPipeline<any, any>): TracingPipeline<any, any> {
		return new TracingPipeline(pipeline, segment);
	}
}
